(function () {
  'use strict';

  function setDrawerState(drawer, isOpen) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', isOpen);
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('drawer-open', isOpen);
  }

  function initMobileMenu() {
    var drawer = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    if (!drawer || !toggle) return;

    toggle.addEventListener('click', function () {
      setDrawerState(drawer, true);
      toggle.setAttribute('aria-expanded', 'true');
      var firstLink = drawer.querySelector('a, button, input');
      if (firstLink) firstLink.focus();
    });

    drawer.querySelectorAll('[data-mobile-menu-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        setDrawerState(drawer, false);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      });
    });
  }

  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;
    document.querySelectorAll('[data-filter-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        setDrawerState(drawer, true);
      });
    });
    drawer.querySelectorAll('[data-filter-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        setDrawerState(drawer, false);
      });
    });
  }

  function initAutoSubmitSelects() {
    document.querySelectorAll('[data-sort-select], [data-localization-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  function initQuantitySelectors(scope) {
    (scope || document).querySelectorAll('[data-quantity-selector]').forEach(function (selector) {
      var input = selector.querySelector('[data-quantity-input]');
      var minus = selector.querySelector('[data-quantity-minus]');
      var plus = selector.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 1;
        input.value = Math.max(parseInt(input.min, 10) || 1, current - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 1;
        input.value = current + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function activateMedia(root, mediaId) {
    if (!mediaId) return;
    root.querySelectorAll('[data-media-id]').forEach(function (media) {
      media.classList.toggle('is-hidden', String(media.getAttribute('data-media-id')) !== String(mediaId));
    });
    root.querySelectorAll('[data-media-target]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', String(thumb.getAttribute('data-media-target')) === String(mediaId));
    });
  }

  function initProductGallery(root) {
    root.querySelectorAll('[data-media-target]').forEach(function (button) {
      button.addEventListener('click', function () {
        activateMedia(root, button.getAttribute('data-media-target'));
      });
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = Number(cents || 0);
    var template = format || '${{amount}}';
    var placeholder = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = placeholder ? placeholder[1] : 'amount';
    var precision = token.indexOf('no_decimals') > -1 ? 0 : 2;
    var decimal = token.indexOf('comma_separator') > -1 ? ',' : '.';
    var thousands = token.indexOf('comma_separator') > -1 ? '.' : ',';
    var number = (value / 100).toFixed(precision);
    var parts = number.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var formatted = parts[0] + (precision ? decimal + parts[1] : '');
    return placeholder ? template.replace(placeholder[0], formatted) : formatted;
  }

  function initProductForm(root) {
    var jsonElement = root.querySelector('[data-product-variants]');
    var form = root.querySelector('[data-product-form]');
    if (!jsonElement || !form) return;

    var variants;
    try {
      variants = JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error('GearzoStore: unable to parse product variants.', error);
      return;
    }

    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-select]'));
    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addText = form.querySelector('[data-add-to-cart-text]');
    var price = form.querySelector('[data-product-price]');
    var comparePrice = form.querySelector('[data-product-compare-price]');
    var status = root.querySelector('[data-variant-status]');
    var moneyFormat = root.getAttribute('data-money-format') || window.themeMoneyFormat || '${{amount}}';

    function updateVariant() {
      var selectedOptions = selects.map(function (select) { return select.value; });
      var variant = variants.find(function (candidate) {
        return candidate.options.every(function (option, index) { return option === selectedOptions[index]; });
      });

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (status) status.textContent = 'This option combination is unavailable.';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, moneyFormat);
      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          comparePrice.classList.remove('is-hidden');
        } else {
          comparePrice.textContent = '';
          comparePrice.classList.add('is-hidden');
        }
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (status) status.textContent = variant.available ? 'Selected variant is available.' : 'Selected variant is sold out.';

      if (variant.featured_media && variant.featured_media.id) {
        activateMedia(root, variant.featured_media.id);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (select) { select.addEventListener('change', updateVariant); });
  }

  function initProducts(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(function (root) {
      initProductGallery(root);
      initProductForm(root);
      initQuantitySelectors(root);
    });
  }

  function initRecommendations() {
    document.querySelectorAll('product-recommendations[data-url]').forEach(function (element) {
      if (element.innerHTML.trim().length > 0) return;
      fetch(element.getAttribute('data-url'))
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var replacement = html.querySelector('product-recommendations');
          if (replacement && replacement.innerHTML.trim().length > 0) {
            element.innerHTML = replacement.innerHTML;
          }
        })
        .catch(function () {
          /* Recommendations are optional; fail silently if the endpoint is unavailable. */
        });
    });
  }

  function closeDrawersOnEscape() {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.mobile-drawer.is-open, .filter-drawer.is-open').forEach(function (drawer) {
        setDrawerState(drawer, false);
      });
      var toggle = document.querySelector('[data-mobile-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function init() {
    initMobileMenu();
    initFilterDrawer();
    initAutoSubmitSelects();
    initQuantitySelectors(document);
    initProducts(document);
    initRecommendations();
    closeDrawersOnEscape();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProducts(event.target);
    initQuantitySelectors(event.target);
    initRecommendations();
  });
})();
